import { ListItemText, Typography, useTheme } from "@mui/material";
import { styled } from "@mui/system";
import { useEffect, useState } from "react";
import shortid from "shortid";
import List from "@mui/material/List";
import Collapse from "@mui/material/Collapse";
import { StyledList, StyledListItemButton, StyledListItemIcon, StyledListItemText, SubItem, } from "./components";
import SubItemCloseIcon from "assets/icons/SubItemCloseIcon";
import SubItemOpenIcon from "assets/icons/SubItemOpenIcon";
import { PriceComponent } from "components/Shared/Dashboard/styled";
import { formatPrice } from "helpers/dataFormat";
import { useSelector } from "react-redux";

const StyledSubItem = styled(SubItem)({
    backgroundColor: "#F0F5FC",
});

const SubListItemText = styled(ListItemText)({
    paddingRight: "10px",
});
const SubListItemTextRight = styled(SubListItemText)({
    maxWidth: "300px",
});

const ListSubItem = ({ data, paddingRight }: { data: balanceSheetChildType; paddingRight: number }) => {
    const theme = useTheme();

    //@ts-ignore
    const { openReports } = useSelector((state) => state).appReducer as { openReports: boolean };
    const [open, setOpen] = useState(openReports);

    useEffect(() => {
        setOpen(openReports);
    }, [openReports]);

    const childPaddingRight = paddingRight + 20;

    const handleClick = () => {
        setOpen(!open);
    };
    if (data.childs) {
        return (
            <>
                <StyledListItemButton
                    disableRipple
                    active={open}
                    onClick={handleClick}
                    paddingRight={childPaddingRight}
                >
                    <StyledListItemIcon>{open ? <SubItemCloseIcon /> : <SubItemOpenIcon />}</StyledListItemIcon>
                    <StyledListItemText>
                        <Typography variant="body2">{`${data.code ? data.code : ''}-${data.title}`}</Typography>
                    </StyledListItemText>
                    <SubListItemTextRight>
                        <PriceComponent
                            color={
                                data.amount > 0
                                    ? theme.palette.success.main
                                    : data.amount === 0
                                        ? theme.palette.primary.main
                                        : theme.palette.error.main
                            }
                            price={formatPrice(data.amount)}
                        />
                    </SubListItemTextRight>
                </StyledListItemButton>
                <Collapse in={open} timeout="auto" unmountOnExit>
                    <List component="div" disablePadding>
                        {data.childs &&
                            data.childs.map((item) => (
                                <ListSubItem paddingRight={childPaddingRight} data={item} key={shortid.generate()} />
                            ))}
                    </List>
                </Collapse>
            </>
        );
    }
    return (
        <SubItem paddingRight={childPaddingRight}>
            <SubListItemText>
                <Typography variant="body2">{`${data.code ? data.code : ""}-${data.title}`}</Typography>
            </SubListItemText>
            <SubListItemTextRight>
                <PriceComponent
                    color={
                        data.amount > 0
                            ? theme.palette.success.main
                            : data.amount === 0
                                ? theme.palette.primary.main
                                : theme.palette.error.main
                    }
                    price={formatPrice(data.amount)}
                />
            </SubListItemTextRight>
        </SubItem>
    );
};

const ProfitAndLossList = ({ data }: { data: reportProfitAndLossDataType }) => {
    const initialPaddingRight = 16;
    const theme = useTheme();
    return (
        <StyledList
            sx={{ width: "100%", bgcolor: "background.paper", marginBottom: "10px", padding: 0 }}
            aria-labelledby="nested-list-subheader"
        >
            <StyledSubItem>
                <SubListItemText>
                    <Typography variant="body2">حساب</Typography>
                </SubListItemText>
                <SubListItemTextRight>
                    <Typography variant="body2">گروه حساب</Typography>
                </SubListItemTextRight>
            </StyledSubItem>
            {data.childs &&
                data.childs.map((item) => (
                    <ListSubItem paddingRight={initialPaddingRight} data={item} key={shortid.generate()} />
                ))}
            <StyledSubItem>
                <SubListItemText>
                    <Typography
                        fontWeight="bold"
                        color={data.profit >= 0 ? theme.palette.success.main : theme.palette.error.main}
                        variant="body2"
                    >
                        {data.profit >= 0 ? "سود" : "زیان"}
                    </Typography>
                </SubListItemText>
                <SubListItemTextRight>
                    <PriceComponent
                        isBold={true}
                        color={data.profit >= 0 ? theme.palette.success.main : theme.palette.error.main}
                        price={formatPrice(data.profit)}
                    />
                </SubListItemTextRight>
            </StyledSubItem>
        </StyledList>
    );
};

export default ProfitAndLossList;
